import React, { useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import Button from '@welldev-group/rcl-button';
import Alert from '@welldev-group/rcl-alert';
import { Link } from 'react-router-dom';
import ConfirmationModal from 'sharedWebpack/ConfirmationModal';
import searchURL from '../../../lib/helpers/searchURL';
import Loader from '../../../../../admin/Orders/Show/ItemsTab/IssueBooking/components/Loader';
import Error from '../../../../../admin/Orders/Show/ItemsTab/IssueBooking/components/Error';
import { FETCHING, FETCHING_FAILED } from '../../../reducers/flight/exchangeQuoteStatus';
import redirectToOrderItem from '../../../../helpers/redirectToOrderItem';
import './styles.scss';

const ExchangeQuoteModal = ({
  isVisible,
  exchangeQuoteStatus,
  searchId,
  itemPath,
  resetExchangeQuoteStatus,
}) => {
  const loadingContent = useMemo(
    () => (
      <div className="d-flex-column row-gap-20">
        <Loader text={I18n.t('components.flight.exchange.quote_modal.loading')} />
        <Alert type="warning-light" hideClose={true} isVisible={true} isIconVisible={false}>
          {I18n.t('components.flight.exchange.quote_modal.warning')}
        </Alert>
      </div>
    ),
    [],
  );

  const getModalBody = () => {
    if (exchangeQuoteStatus === FETCHING) return loadingContent;

    if (exchangeQuoteStatus === FETCHING_FAILED) {
      return (
        <Error
          className="exchange-quote-modal__error"
          isWithAction={true}
          error={{
            header: I18n.t('components.flight.exchange.quote_modal.fail.header'),
            message: I18n.t('components.flight.exchange.quote_modal.fail.message'),
          }}
        >
          <div className="d-flex align-center column-gap-8">
            <Button
              size="small"
              primary={true}
              label={I18n.t('components.flight.exchange.quote_modal.actions.back_to_order')}
              onClick={() => {
                redirectToOrderItem(itemPath);
              }}
            />
            <Link to={searchURL('flight', searchId)}>
              <Button
                size="small"
                label={I18n.t('components.flight.exchange.quote_modal.actions.back_to_results')}
              />
            </Link>
          </div>
        </Error>
      );
    }

    return loadingContent;
  };

  useEffect(
    () => () => {
      resetExchangeQuoteStatus();
    },
    [],
  );

  return (
    <ConfirmationModal
      className="exchange-quote-modal"
      isModalOpen={isVisible}
      confirmationHeader={null}
      type=""
      withAction={false}
      subHeader={getModalBody()}
    />
  );
};

ExchangeQuoteModal.defaultProps = {
  exchangeQuoteStatus: null,
  searchId: '',
  itemPath: '',
};

ExchangeQuoteModal.propTypes = {
  exchangeQuoteStatus: PropTypes.string,
  isVisible: PropTypes.bool.isRequired,
  searchId: PropTypes.string,
  itemPath: PropTypes.string,
  resetExchangeQuoteStatus: PropTypes.func.isRequired,
};

export default ExchangeQuoteModal;
